
import Router from 'vue-router'


import List from '../pages/financial/List.vue'

import store1 from "../store/index.js";
import Landing from "../pages/common-apps/Landing.vue";

const baseRoutes = [
  {
    path: '/',
    redirect: { name: 'Landing' }
  },
  {
    path: '/landing',
    name: 'Landing',
    component: Landing,
    meta: { bodyClass: 'landing-page' }
  }
] // to comment Landing route when using on dev mode

const financialRoutes = [
  {
    path: '/list',
    name: 'Financial List',
    component: List,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  }
]


const routes = baseRoutes.concat(financialRoutes)

const routerFinancial = new Router({
  routes,
  mode: 'history',
  base: 'fin'
})

routerFinancial.beforeEach((to, from, next) => {
  // vueBodyClass.guard(to, next)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store1.getters['account/isAuthenticated']) {
      next()
      return
    }
    next('/landing')
  } else {
    next()
  }
})


// const MyComponent = () => routerFamilial
//
// export {MyComponent};

export default routerFinancial


